import { createContext, useContext } from "react";

type CompanySettings = {
  currency: string;
  timezone?: string;
  customNaming?:
    | {
        tax: string | null;
        taxes: string | null;
        estimate: string | null;
        estimates: string | null;
        invoice: string | null;
        invoices: string | null;
      }
    | undefined;
};

const CompanySettingsContext = createContext<CompanySettings | undefined>(
  undefined,
);

export function useCompanySettings() {
  const context = useContext(CompanySettingsContext);
  if (context === undefined) {
    throw new Error(
      "useCompanySettings must be used within a CompanySettingsProvider",
    );
  }
  return context;
}

export function CompanySettingsProvider({
  children,
  settings,
}: {
  children: React.ReactNode;
  settings: CompanySettings;
}) {
  return (
    <CompanySettingsContext.Provider value={settings}>
      {children}
    </CompanySettingsContext.Provider>
  );
}
